const pdfPageWidthOnLandscape = 282;
const idtUrl = 'https://www.idtdna.com/site/account';
const strainColors: string[] = [
    '#E06666',
    '#648BEF',
    '#5B9E18',
    '#BF8A18',
    '#12A2AF',
    '#600000',
    '#F600E2',
    '#749191',
    '#8F9900',
    '#E07800',
    '#F00',
    '#0036FF',
    '#9C00FF',
    '#4C4C32',
];

export const GlobalVariablesHelper = {
    pdfPageWidthOnLandscape,
    idtUrl,
    strainColors,
};
